"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cognitoAuthenticated: function cognitoAuthenticated(state) {
    var now = Math.floor(new Date() / 1000);

    return !(state.user === null || state.user && state.user.tokens === null || now > state.user.expiration);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@smart/vue-auth-cognito/lib/getters.js
// module id = 8KqT
// module chunks = 0